// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"5cb51d6c","480":"00da9d26","754":"6399d675","832":"abda2fee"}[chunkId] + ".chunk.css";
};